import React from "react";

const NotFound = () => {
  return (
    <div>
      <img src="https://i.ibb.co/Kycch85/NotFound.jpg" alt="notfound" />
    </div>
  );
};

export default NotFound;
